<template>
    <div class="index-footer-wapper">
      <p class="copyright">Copyright &nbsp;<i class="iconfont">&#xe674;</i>&nbsp; {{date}} 苏州市朝旭科技有限公司 版权所有</p>
      <a class="copyright" href="https://beian.miit.gov.cn/">网站备案号：苏ICP备19003956号-5</a>
    </div>
</template>

<script>
import moment from 'moment'

export default {
  name:"copyrightfooter",
  data(){
    return{
      date: ''
    }
  },
  mounted(){
    this.date = new moment().format('YYYY')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modules/CopyrightFooter.vue